import LevelModel from './LevelModel';

class ConfigModel {
  constructor({ game, config: data }) {
    this.data = { ...data };
    // phaser has it's own config
    // for (let i in this.game.config) {
    //   this[i] = this.game.config[i];
    // }

    this.allow_game_logs = __DEBUG__;

    this.game = this.data.game;

    this.show_rotate_screen = this.game.show_rotate_screen;
    this.start_at_level = this.game.start_at_level;
    this.invincible_mode = false;

    this.audio = this.data.audio;
    this.audioIE = this.data.audioIE;
    this.audioSprites = this.data.audioSprites;
    this.screenhud = this.data.screenhud;
    this.buttons = this.data.buttons;

    this.levels = [];

    this.levels = this.data.game_levels.reduce((arr, level) => {
      arr.push(new LevelModel({ game, config: level }));
      return arr;
    }, []);

    this.vehicleBounds = [];
    this.vehicleBounds = this.data.vehicleBounds.reduce((arr, vehicle) => {
      let bounds = { ...vehicle };
      arr.push(bounds);
      return arr;
    }, []);

    if (__WATCH__) {
    }
  }

  getIntroMessageById(id) {
    return this.introMessages[id];
  }

  getLevelData(level) {
    return this.levels[level - 1];
  }

  getLevelCount() {
    return this.levels.length;
  }

  getVehicleBounds(vehicleID) {
    let bounds = {};

    this.vehicleBounds.forEach((element) => {
      if (element.id === vehicleID) {
        bounds = element['bounds'];
      }
    });

    return bounds;
  }
}
export default ConfigModel;
